import React, { useEffect, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import Select from "react-select";
import {
  CURRENCY,
  CURRENCY_CRYPTO_NAME,
  CURRENCY_NAME,
  GOLD_QUANTITY_LIST,
  I_POP_OVER,
  PRODUCT_GOLD_TYPE,
  SELECT_BOX_THEME,
  SUBSCRIPTION_MODULE_TYPE,
  SUPPORTED_PAYMENT_METHOD,
  SUPPORTED_PAYMENT_METHOD_NAME,
} from "../../constants";
import { useLocation, useNavigate } from "react-router";
import { RoutesPaths } from "../../Router/constant";
import { useDispatch, useSelector } from "react-redux";
import CurrencyFormat from "../../components/currencyFormat/currencyFormat";
import Currency from "../../components/currency";
import {
  saveManualDetails,
  createStripeTokenAction,
  extraFeeCalcAction,
  setBankTranferBackTrigger,
  currencyConversionCalcHighAction,
  setCurrencyWatch,
  payWithCryptoAction,
  setTripleaUrl,
  selectedCardFunc,
  setPaymentSteps,
  setQuantity,
  createManualEntryAction,
  setOpenCartPage,
  subscriptionPlan,
  getIsPlanValidAction,
} from "../../actions/stripe";
import InfoModalStatic from "../dashboard/infoModalStatic";
import toast from "react-hot-toast";
import PayWithCryptoPopup from "./PayWithCryptoPopup";
import ProductQuantity from "../../components/buyProduct/ProductQuantity";
import SelectPayment from "../../components/buyProduct/SelectPayment";
import PayWithCard from "../../components/buyProduct/PayWithCard";
import PaymentStatus from "../../components/buyProduct/PaymentStatus";
import BankDetail from "./BankDetail";
import PaymentSteps from "./PaymentSteps";
import BreadcrumbsPayment from "../../components/header/breadcrumbsPayment";
import { setFailedMessage } from "../../actions/message";
import GetToaster from "../../components/header/getToaster";
import PlanInvalid from "./PlanInvalid";
import { isMobile } from "react-device-detect";

export default function BankTransfer() {
  const dispatch = useDispatch();
  const {
    control,
    register,
    handleSubmit,
    getValues,
    watch,
    setValue,
    trigger,
    formState: { errors },
  } = useForm({
    defaultValues: {
      saveInfo: "true",
    },
  });
  const [loader, setLoader] = useState(false);
  const { toastMessage } = useSelector(state => state.message)

  const {
    stripePlans,
    paymentMethodSelection,
    stripeType,
    savedbankInfoDetails,
    isOverrideProduct,
    stripeSubscription,
    cartAmount,
    forceCartAmount,
    triggerBankTransferBack,
    selectedQuantity,
    isManualPayment,
    isManualPaymentType,
    selectedStep,
    selectedCard,
    isTripleaUrl
  } = useSelector((state) => state.stripe);
  const { planLoader } = useSelector((state) => state.subscriptionPlanProducts);
  const { bankDetail } = useSelector((state) => state.settings);
  const location = useLocation();
  const pathnames = location?.pathname?.split("/").filter((x) => x);
  const planId = pathnames?.[pathnames.length - 2];
  const { selectedCompany } = useSelector((state) => state.company);
  const currencyWatch = watch("currency");
  const saveInfoWatch = watch("saveInfo");
  const amountWatch = watch("amount");
  const cryptoAmountWatch = watch("cryptoAmount");
  const bankTransferDetail = (bankDetail && bankDetail.find(x => x.id.toLowerCase() === currencyWatch?.value)) || {}

  const [infoModalStaicShow, setInfoModalStaticShow] = useState(false);
  const [infoModalStaicShowType, setInfoModalStaticShowType] = useState(null);


  useEffect(() => {
    const getPlanValidDetail = async () => {
      var resp = await dispatch(getIsPlanValidAction(planId))
      if (resp?.data === 'Expired') {
        dispatch(setPaymentSteps(0))
      } else {
        dispatch(setPaymentSteps(1))
      }
    }
    getPlanValidDetail()
  }, [dispatch, planId])


  const handleClickInfo = (type) => {
    setInfoModalStaticShow(true);
    setInfoModalStaticShowType(type);
  };

  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [selectedStep])

  useEffect(() => {
    register("baseAmountRate", { required: true });
    register("transactionFee", { required: false });
    register("amount", { required: true });
    register("cryptoAmount", { required: false });
  }, []);

  const calcExtraFeeCharges = () => {
    const payload = {
      price: stripePlans?.price,
      quantity: selectedQuantity.value,
      paymentMethodSelection: parseInt(paymentMethodSelection),
      goldType: stripePlans?.goldProductType?.value,
    };
    dispatch(extraFeeCalcAction(payload?.paymentMethodSelection, parseInt(stripeType), payload));
  };

  useEffect(() => {
    const checkIfSubscriptionDetailsAvailable = () => {
      if (stripePlans && Object.keys(stripePlans).length === 0) {
        if (pathnames[0] == "payment") {
          navigate(RoutesPaths.PAYMENT);
        } else if (pathnames[0] == "dashboard") {
          navigate(RoutesPaths.DASHBOARD_PRODUCT_PAGE.replace(":slug", planId));
        } else if (pathnames[0] == "book-of-business") {
          navigate(RoutesPaths.BOOK_OF_BUSINESS_PRODUCT_PAGE.replace(":slug", planId));
        } else if (pathnames[0] == "home") {
          navigate(RoutesPaths.HOME_PRODUCT_PAGE.replace(":slug", planId));
        } else if (pathnames[0] == "pay") {
          navigate(RoutesPaths.MESSAGE_DETAIL + '?room=' + location?.state?.sid || "");
        } else {
          navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", planId));
        }
      } else {
        if (!triggerBankTransferBack) {
          if (stripePlans?.price) {
            calcExtraFeeCharges();
          }
        }
      }
    };
    checkIfSubscriptionDetailsAvailable();
  }, [stripePlans, selectedQuantity, dispatch, selectedStep]);

  const onSubmit = async (data) => {
    if (data?.amount > 0) {
      setLoader(true);
      let additionalPayload = {
        subscriptionModuleType: parseInt(stripeType),
        paymentMethodSelection: paymentMethodSelection,
        planId: (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
          ? stripePlans?._id
          : stripePlans?.id) || null,
        company: selectedCompany?.id,
        baseRequestCurrency: stripePlans?.currency?.value || null,
      };
      if (
        additionalPayload.subscriptionModuleType ===
        SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL
      ) {
        additionalPayload.capital = stripePlans?.capital?.id || null;
        additionalPayload.baseRequestShareType =
          stripePlans?.capital?.shareType || null;
      }
      const payload = { ...data, ...additionalPayload };
      if (paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) {
        handleProceed();
      } else if (
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
      ) {
        await dispatch(saveManualDetails(payload));
        handleCryptoProceed();
      } else {
        await dispatch(saveManualDetails(payload));
        await handleCompleteForm(payload);
      }
    } else {
      dispatch(setFailedMessage("Amount must be greater than 0"));
    }
  };

  const handleCompleteForm = async (payload) => {
    try {
      const resp = await dispatch(createManualEntryAction(payload));
      if (resp?.status) {
        setTimeout(() => {
          setLoader(false);
        }, 1000);
      } else {
        setLoader(false);
      }
    } catch (error) { }
    setLoader(false);
  };

  useEffect(() => {
    if (savedbankInfoDetails && Object.keys(savedbankInfoDetails).length > 0) {
      setValue(
        "quantity",
        savedbankInfoDetails.quantity ?? GOLD_QUANTITY_LIST[0]
      );
      setValue("currency", savedbankInfoDetails?.currency);
      setValue("sendingInstruction", savedbankInfoDetails?.sendingInstruction);
      setValue("number", savedbankInfoDetails.number);
      setValue("nickName", savedbankInfoDetails.nickName);
    }
  }, [setValue, savedbankInfoDetails]);

  useEffect(() => {
    calculateCartForceAction();
  }, [cartAmount, isManualPayment]);

  const calculateCartForceAction = (fromForce = null) => {
    const payload = {
      baseReqCurrency: stripePlans?.currency?.value,
      from: fromForce ? fromForce : stripePlans?.currency?.value,
      to: currencyWatch?.value,
      price: parseFloat(isManualPayment) > 0 ? isManualPayment : isManualPaymentType ? isManualPayment : stripePlans?.price,
      paymentMethodSelection: parseInt(paymentMethodSelection),
      moduleType: parseInt(stripeType),
      quantity: selectedQuantity.value,
      isManual: parseFloat(isManualPayment) > 0 ? true : false,
      goldType: stripePlans?.goldProductType?.value,
    };
    if (parseFloat(isManualPayment) > 0) {
      setValue("cryptoAmount", isManualPayment);
    } else {
      setValue("cryptoAmount", stripePlans?.price);
    }
    dispatch(currencyConversionCalcHighAction(payload));
  };

  useEffect(() => {
    if (
      stripePlans?.goldProductType?.value === PRODUCT_GOLD_TYPE.KILOGRAM &&
      [CURRENCY.INR, CURRENCY.CNY].includes(currencyWatch?.value)
    ) {
      dispatch(setQuantity(GOLD_QUANTITY_LIST[0]))
    }
    calculateCartForceAction();
  }, [currencyWatch]);

  useEffect(() => {
    dispatch(setBankTranferBackTrigger(false));
    if (!triggerBankTransferBack) {
      calcExtraFeeCharges();
    }
  }, [selectedQuantity, triggerBankTransferBack]);

  useEffect(() => {
    setValue("baseAmountRate", forceCartAmount?.baseAmountRate);
    setValue("transactionFee", forceCartAmount?.transactionFees);
    setValue("amount", forceCartAmount?.payableAmount);
    if (
      paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO &&
      (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PLAN ||
        parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PRODUCT ||
        parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB)
    ) {
      setValue("cryptoAmount", stripePlans?.price);
    }
  }, [forceCartAmount]);

  // Define a variable to hold the validation rules based on the condition
  let validationRules = {
    required: {
      value: true,
      message:
        paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
          ? "Enter your account number"
          : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
            ? "Enter you wallet address"
            : "",
    },
  };

  if (
    [
      SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER,
      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO,
    ].includes(paymentMethodSelection)
  ) {
    validationRules.pattern = {
      value: /^[a-zA-Z0-9]+$/,
      message: "Please enter only alphanumeric value",
    };
  }

  const handleProceed = async () => {
    if (amountWatch && stripeSubscription && selectedCompany.id) {
      let payload = {
        companyId: selectedCompany.id,
        planId:
          parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
            ? stripeSubscription._id
            : stripeSubscription.id,
        subscriptionModuleType: parseInt(stripeType),
        paymentMethodSelection: paymentMethodSelection,
        quantity: selectedQuantity,
        currency: currencyWatch,
        baseAmountRate: parseFloat(forceCartAmount?.baseAmountRate),
        baseRequestCurrency: stripeSubscription?.currency?.value || null,
        transactionFee: parseFloat(forceCartAmount?.transactionFees),
        amount: parseFloat(amountWatch),
        cardId: selectedCard?.id

      };
      if (payload.subscriptionModuleType === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL) {
        payload.baseRequestShareType = stripeSubscription?.capital?.shareType;
        payload.capital = stripeSubscription?.capital?.id;
        payload.loadStripeData = {
          currency: stripeSubscription?.currency?.value,
          amount: parseFloat(amountWatch),
        };
      }
      if (payload.planId || Object.keys(payload.loadStripeData).length > 0) {
        await dispatch(createStripeTokenAction(payload));
        setLoader(false);
      } else {
        setLoader(false);
      }
    } else {
      dispatch(setFailedMessage("Could not able to proceed, please contact administrator."));
      setLoader(false);
    }
  };

  const handleCryptoProceed = async () => {
    if (amountWatch && stripeType && selectedCompany.id) {
      let payload = {
        company: selectedCompany.id,
        planId:
          (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.BOB
            ? stripePlans?._id
            : stripePlans?.id) || null,
        subscriptionModuleType: parseInt(stripeType),
        paymentMethodSelection: paymentMethodSelection,
        quantity: selectedQuantity,
        currency: currencyWatch,
        baseAmountRate: parseFloat(cryptoAmountWatch)
          ? parseFloat(cryptoAmountWatch) * parseFloat(selectedQuantity?.value)
          : parseFloat(amountWatch),
        baseRequestCurrency: stripePlans?.currency?.value || null,
        amount: parseFloat(amountWatch)
      };
      if (payload.subscriptionModuleType === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL) {
        payload.baseRequestShareType = stripePlans?.capital?.shareType;
        payload.capital = stripePlans?.capital?.id;
      }
      var resp = await dispatch(payWithCryptoAction(payload));
      setLoader(false);
      if (resp.status) {
        if (resp?.data?.hosted_url) {
          dispatch(setTripleaUrl(resp?.data?.hosted_url, true));
        }
      } else {
        dispatch(setFailedMessage(resp?.data?.message ? "Something wen't wrong" : resp?.data ? resp?.data : "Something wen't wrong"));
      }
    } else {
      dispatch(setFailedMessage("Could not able to proceed, please contact administrator."));
      setLoader(false);
    }
  };

  useEffect(() => {
    dispatch(
      setCurrencyWatch(currencyWatch && currencyWatch?.value?.toUpperCase())
    );
  }, [currencyWatch]);

  const [isTransactionVisible, setTransactionVisible] = useState(true);

  const toggleTransactionVisibility = () => {
    setTransactionVisible(!isTransactionVisible);
  };

  const handleToggle = (value) => {
    setValue("saveInfo", value.target.checked)
    trigger("saveInfo")
  };

  const handleStep = value => {
    let stepValue = selectedStep - value;
    if (stepValue >= 1) {
      dispatch(setPaymentSteps(stepValue));
      dispatch(setOpenCartPage(false))
    }
    if (stepValue === 0) {
      if (pathnames[0] === "payment") {
        navigate(RoutesPaths.PAIDUPDETAILPAYMENT.replace(":slug", planId));
      } else if (pathnames[0] === "dashboard") {
        navigate(RoutesPaths.DASHBOARD_PRODUCT_PAGE.replace(":slug", planId));
      } else if (pathnames[0] === "book-of-business") {
        navigate(RoutesPaths.BOOK_OF_BUSINESS_PRODUCT_PAGE.replace(":slug", planId));
      } else if (pathnames[0] === "pay") {
        navigate(RoutesPaths.MESSAGE_DETAIL + '?room=' + location?.state?.sid);
      } else if (pathnames[0] === "share-paid-up-capital") {
        navigate(RoutesPaths.PAY_PAIDUP_PAGE.replace(":slug", planId));
      } else {
        navigate(RoutesPaths.PRODUCT_PAGE.replace(":slug", planId));
      }

    }
  };

  const forwardPaymentPage = async item => {
    if (item === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER || item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO) {
      dispatch(setPaymentSteps(3));
      dispatch(selectedCardFunc(null));
    } else if (item === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) {
      dispatch(subscriptionPlan(stripePlans));
      dispatch(setPaymentSteps(3));
    } else {
      // setFailedMessage('Please select a valid payment method');
    }
    dispatch(setOpenCartPage(false));
  };

  return (
    <>
      {selectedStep === 0 &&
        <div className='mainHeader'>
          <div className='headerClass'>
            <div onClick={() => {
              navigate(RoutesPaths.HOME)
            }}>
              <svg width={isMobile ? 150 : 191} height="40" viewBox="0 0 191 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M168.873 39.9578V8.99874H174.092V12.722H174.399C174.673 12.1748 175.059 11.5933 175.557 10.9777C176.056 10.3522 176.73 9.81962 177.58 9.37986C178.43 8.93033 179.515 8.70557 180.835 8.70557C182.574 8.70557 184.142 9.15021 185.54 10.0395C186.947 10.919 188.061 12.2236 188.882 13.9534C189.713 15.6733 190.128 17.7842 190.128 20.2859C190.128 22.7583 189.723 24.8594 188.911 26.5891C188.1 28.3188 186.996 29.6381 185.599 30.547C184.201 31.4558 182.618 31.9102 180.849 31.9102C179.559 31.9102 178.489 31.6952 177.639 31.2652C176.789 30.8352 176.105 30.3173 175.587 29.7114C175.079 29.0957 174.683 28.5143 174.399 27.967H174.179V39.9578H168.873ZM174.077 20.2566C174.077 21.7127 174.282 22.988 174.693 24.0825C175.113 25.177 175.714 26.0321 176.496 26.6477C177.287 27.2536 178.245 27.5566 179.369 27.5566C180.541 27.5566 181.523 27.2439 182.315 26.6184C183.107 25.9832 183.703 25.1184 184.103 24.0239C184.514 22.9196 184.719 21.6638 184.719 20.2566C184.719 18.8591 184.519 17.618 184.118 16.5333C183.717 15.4485 183.121 14.5983 182.33 13.9827C181.538 13.367 180.551 13.0592 179.369 13.0592C178.235 13.0592 177.272 13.3572 176.481 13.9534C175.689 14.5495 175.088 15.385 174.678 16.46C174.277 17.535 174.077 18.8005 174.077 20.2566Z" fill="#3B6F97" />
                <path d="M154.984 31.5149V8.99925H160.129V12.7519H160.364C160.774 11.4521 161.478 10.4505 162.474 9.74684C163.481 9.03345 164.629 8.67676 165.919 8.67676C166.212 8.67676 166.54 8.69142 166.901 8.72073C167.273 8.74028 167.581 8.77448 167.825 8.82334V13.7047C167.6 13.6265 167.243 13.5581 166.755 13.4995C166.276 13.431 165.812 13.3968 165.362 13.3968C164.395 13.3968 163.525 13.6069 162.753 14.0272C161.991 14.4376 161.39 15.0093 160.95 15.7422C160.51 16.4752 160.29 17.3205 160.29 18.2782V31.5149H154.984Z" fill="#3B6F97" />
                <path d="M142.168 31.9542C139.969 31.9542 138.063 31.4704 136.451 30.503C134.838 29.5355 133.587 28.182 132.698 26.4425C131.819 24.703 131.379 22.6704 131.379 20.3445C131.379 18.0187 131.819 15.9811 132.698 14.2319C133.587 12.4826 134.838 11.1242 136.451 10.1568C138.063 9.1893 139.969 8.70557 142.168 8.70557C144.366 8.70557 146.272 9.1893 147.885 10.1568C149.497 11.1242 150.743 12.4826 151.622 14.2319C152.512 15.9811 152.956 18.0187 152.956 20.3445C152.956 22.6704 152.512 24.703 151.622 26.4425C150.743 28.182 149.497 29.5355 147.885 30.503C146.272 31.4704 144.366 31.9542 142.168 31.9542ZM142.197 27.7032C143.389 27.7032 144.386 27.3758 145.187 26.721C145.989 26.0565 146.585 25.1672 146.976 24.0532C147.376 22.9391 147.577 21.698 147.577 20.3299C147.577 18.952 147.376 17.706 146.976 16.5919C146.585 15.4681 145.989 14.5739 145.187 13.9094C144.386 13.2449 143.389 12.9126 142.197 12.9126C140.975 12.9126 139.959 13.2449 139.148 13.9094C138.347 14.5739 137.746 15.4681 137.345 16.5919C136.954 17.706 136.759 18.952 136.759 20.3299C136.759 21.698 136.954 22.9391 137.345 24.0532C137.746 25.1672 138.347 26.0565 139.148 26.721C139.959 27.3758 140.975 27.7032 142.197 27.7032Z" fill="#3B6F97" />
                <path d="M120.82 31.9542C118.573 31.9542 116.643 31.4607 115.03 30.4737C113.428 29.4866 112.191 28.1234 111.322 26.3839C110.462 24.6346 110.032 22.6215 110.032 20.3445C110.032 18.0578 110.471 16.0398 111.351 14.2905C112.231 12.5315 113.472 11.1633 115.074 10.1861C116.687 9.19907 118.592 8.70557 120.791 8.70557C122.619 8.70557 124.236 9.04271 125.643 9.71701C127.06 10.3815 128.189 11.3246 129.029 12.5461C129.87 13.7579 130.349 15.1749 130.466 16.7971H125.394C125.189 15.7124 124.7 14.8084 123.928 14.0853C123.166 13.3524 122.145 12.9859 120.864 12.9859C119.78 12.9859 118.827 13.2791 118.006 13.8654C117.185 14.442 116.545 15.2726 116.086 16.3574C115.636 17.4421 115.411 18.7419 115.411 20.2566C115.411 21.7909 115.636 23.1101 116.086 24.2144C116.535 25.3089 117.166 26.1542 117.977 26.7504C118.798 27.3367 119.76 27.6299 120.864 27.6299C121.646 27.6299 122.345 27.4833 122.961 27.1901C123.586 26.8872 124.109 26.4523 124.529 25.8855C124.949 25.3187 125.238 24.6297 125.394 23.8186H130.466C130.339 25.4115 129.87 26.8237 129.059 28.055C128.248 29.2765 127.143 30.2342 125.746 30.9281C124.348 31.6121 122.707 31.9542 120.82 31.9542Z" fill="#3B6F97" />
                <path d="M98.1833 31.9542C95.9845 31.9542 94.0789 31.4704 92.4664 30.503C90.854 29.5355 89.6031 28.182 88.7138 26.4425C87.8343 24.703 87.3945 22.6704 87.3945 20.3445C87.3945 18.0187 87.8343 15.9811 88.7138 14.2319C89.6031 12.4826 90.854 11.1242 92.4664 10.1568C94.0789 9.1893 95.9845 8.70557 98.1833 8.70557C100.382 8.70557 102.288 9.1893 103.9 10.1568C105.513 11.1242 106.759 12.4826 107.638 14.2319C108.527 15.9811 108.972 18.0187 108.972 20.3445C108.972 22.6704 108.527 24.703 107.638 26.4425C106.759 28.182 105.513 29.5355 103.9 30.503C102.288 31.4704 100.382 31.9542 98.1833 31.9542ZM98.2126 27.7032C99.4048 27.7032 100.402 27.3758 101.203 26.721C102.004 26.0565 102.6 25.1672 102.991 24.0532C103.392 22.9391 103.592 21.698 103.592 20.3299C103.592 18.952 103.392 17.706 102.991 16.5919C102.6 15.4681 102.004 14.5739 101.203 13.9094C100.402 13.2449 99.4048 12.9126 98.2126 12.9126C96.9911 12.9126 95.9747 13.2449 95.1636 13.9094C94.3623 14.5739 93.7613 15.4681 93.3606 16.5919C92.9697 17.706 92.7742 18.952 92.7742 20.3299C92.7742 21.698 92.9697 22.9391 93.3606 24.0532C93.7613 25.1672 94.3623 26.0565 95.1636 26.721C95.9747 27.3758 96.9911 27.7032 98.2126 27.7032Z" fill="black" />
                <path d="M65.0728 31.5146V1.49365H70.3792V12.7222H70.5991C70.8727 12.1749 71.2587 11.5935 71.7571 10.9778C72.2555 10.3524 72.9298 9.81976 73.78 9.38C74.6302 8.93047 75.7149 8.70571 77.0342 8.70571C78.7737 8.70571 80.3422 9.15035 81.7396 10.0396C83.1469 10.9192 84.2609 12.2238 85.0818 13.9535C85.9125 15.6735 86.3278 17.7843 86.3278 20.286C86.3278 22.7585 85.9222 24.8595 85.1111 26.5893C84.3 28.319 83.1957 29.6383 81.7983 30.5471C80.4008 31.4559 78.8177 31.9103 77.0489 31.9103C75.7589 31.9103 74.6888 31.6954 73.8386 31.2654C72.9884 30.8354 72.3044 30.3174 71.7864 29.7115C71.2782 29.0959 70.8825 28.5144 70.5991 27.9672H70.2912V31.5146H65.0728ZM70.2766 20.2567C70.2766 21.7128 70.4818 22.9881 70.8922 24.0826C71.3125 25.1771 71.9135 26.0322 72.6953 26.6479C73.4868 27.2538 74.4445 27.5567 75.5683 27.5567C76.741 27.5567 77.7232 27.244 78.5147 26.6186C79.3063 25.9834 79.9024 25.1185 80.3031 24.024C80.7135 22.9197 80.9188 21.664 80.9188 20.2567C80.9188 18.8593 80.7184 17.6182 80.3177 16.5334C79.9171 15.4487 79.321 14.5985 78.5294 13.9828C77.7378 13.3672 76.7508 13.0593 75.5683 13.0593C74.4347 13.0593 73.4722 13.3574 72.6806 13.9535C71.889 14.5496 71.288 15.3852 70.8776 16.4601C70.4769 17.5351 70.2766 18.8006 70.2766 20.2567Z" fill="black" />
                <path d="M30.2681 31.5144V8.99874H35.34V12.8246H35.6038C36.0729 11.5347 36.8498 10.5281 37.9345 9.80496C39.0193 9.07203 40.3141 8.70557 41.8191 8.70557C43.3436 8.70557 44.6287 9.07692 45.6743 9.81962C46.7297 10.5526 47.4724 11.5542 47.9024 12.8246H48.137C48.6354 11.5738 49.4758 10.577 50.6582 9.83428C51.8505 9.08181 53.2626 8.70557 54.8946 8.70557C56.9664 8.70557 58.657 9.36032 59.9665 10.6698C61.276 11.9793 61.9307 13.8898 61.9307 16.4014V31.5144H56.6097V17.2222C56.6097 15.8248 56.2383 14.8036 55.4956 14.1586C54.7529 13.5038 53.8441 13.1765 52.7691 13.1765C51.4889 13.1765 50.4872 13.5771 49.7641 14.3785C49.0507 15.17 48.694 16.201 48.694 17.4714V31.5144H43.4902V17.0024C43.4902 15.8394 43.1384 14.9111 42.4347 14.2172C41.7409 13.5234 40.8321 13.1765 39.7082 13.1765C38.946 13.1765 38.2521 13.3719 37.6267 13.7628C37.0013 14.1439 36.5029 14.6863 36.1315 15.3899C35.7602 16.0838 35.5745 16.8949 35.5745 17.8232V31.5144H30.2681Z" fill="black" />
                <path d="M21.9822 31.5146V8.99891H27.2887V31.5146H21.9822ZM24.6501 5.80333C23.8097 5.80333 23.0865 5.52482 22.4806 4.96779C21.8747 4.40098 21.5718 3.7218 21.5718 2.93023C21.5718 2.12889 21.8747 1.44971 22.4806 0.892681C23.0865 0.325881 23.8097 0.0424805 24.6501 0.0424805C25.5003 0.0424805 26.2235 0.325881 26.8196 0.892681C27.4255 1.44971 27.7284 2.12889 27.7284 2.93023C27.7284 3.7218 27.4255 4.40098 26.8196 4.96779C26.2235 5.52482 25.5003 5.80333 24.6501 5.80333Z" fill="black" />
                <path d="M5.79487 24.4491L5.78022 18.0433H6.63042L14.722 8.99888H20.9226L10.9694 20.0808H9.86998L5.79487 24.4491ZM0.95752 31.5146V1.49365H6.26395V31.5146H0.95752ZM15.0885 31.5146L7.75913 21.2682L11.3358 17.5302L21.4357 31.5146H15.0885Z" fill="black" />
              </svg>
            </div>
            <div onClick={() => {
              navigate(RoutesPaths.HOME)
            }} className='loginBtnClass'>
              Dashboard
              <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M7.49984 14.5833H2.9165M5.4165 10H1.6665M7.49984 5.41667H3.33317M14.1665 2.5L8.66947 10.1958C8.42617 10.5365 8.30452 10.7068 8.30979 10.8488C8.31437 10.9724 8.37365 11.0876 8.47159 11.1632C8.58407 11.25 8.79337 11.25 9.21196 11.25H13.3332L12.4998 17.5L17.9969 9.80416C18.2402 9.46353 18.3618 9.29322 18.3566 9.15123C18.352 9.0276 18.2927 8.9124 18.1948 8.83682C18.0823 8.75 17.873 8.75 17.4544 8.75H13.3332L14.1665 2.5Z" stroke="white" strokeWidth="1.66667" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
            </div>
          </div>
        </div>
      }
      {selectedStep > 0 && selectedStep !== 4 &&
        <div className="desktop-breadcrumb-header">
          <BreadcrumbsPayment
            selectedStep={selectedStep}
            handleStep={handleStep}
            mobileHeader={selectedStep === 1 ? stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.FUNDS ? "Add funds" : (stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.CUSTOM || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.PLAN || stripePlans?.planType?.value === SUBSCRIPTION_MODULE_TYPE.BUSINESSPLAN) ? "Select amount" : "Select Quantity" : selectedStep === 2 ?
              "Select Payment Method" : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                ? SUPPORTED_PAYMENT_METHOD_NAME[paymentMethodSelection]
                : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                  ? `Crypto transfer`
                  : "-"}
            loader={planLoader} />
        </div>
      }
      <div className="container-fluid">
        {toastMessage && <GetToaster />}
        {selectedStep > 0 &&
          <PaymentSteps selectedStep={selectedStep} />
        }
      </div>
      <div className="container bankPage">
        <div className="row buyProductSection">
          <div className="col-md-8">
            <form>
              {selectedStep === 0 &&
                <PlanInvalid />
              }
              {selectedStep === 1 && <ProductQuantity />
              }
              {selectedStep === 2 && <SelectPayment forwardPaymentPage={forwardPaymentPage} />}
              {selectedStep === 3 &&
                <div className="container">
                  <div className="row buyProductSectionBg">
                    <div className="col-md-12">
                      <div className="userDetail">
                        {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD && <PayWithCard />}
                        {(paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER || paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD) && (
                          <p className="header">
                            {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                              ? "I will be sending the wire from the following bank/institution"
                              : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                ? `I will be paying by card in the following currency`
                                : "-"}
                          </p>
                        )}
                        <div className="innerDetail">
                          <div className="row">
                            {!isTripleaUrl &&
                              <div className="col-md-12 mb-3">
                                <div className="inputHolder inputHolderColumn m-0">
                                  <label className="label">
                                    Select{" "}
                                    {paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                                      paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                      ? "currency"
                                      : paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? "token"
                                        : ""}
                                  </label>
                                  <Controller
                                    name="currency"
                                    rules={{ required: true }}
                                    control={control}
                                    // defaultValue={null}
                                    render={({ field }) => (
                                      <Select
                                        theme={SELECT_BOX_THEME}
                                        className="select-border bankTransferSelectField customBankTransferField"
                                        {...field}
                                        options={
                                          paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ||
                                            paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                            ? CURRENCY_NAME
                                            : paymentMethodSelection ===
                                              SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                              ? CURRENCY_CRYPTO_NAME
                                              : []
                                        }
                                        getOptionLabel={(option) => (
                                          <div className="selectLabelContent">
                                            <img src={`assets/img/${option.value}.png`} alt={option.value} style={{ marginRight: 10, width: 20, height: 20 }} />
                                            {option.value.toUpperCase()}
                                          </div>
                                        )}
                                        getOptionValue={(option) => option.value}
                                        isClearable={false}
                                        placeholder="Select currency"
                                      />
                                    )}
                                  />
                                </div>

                                {errors.currency?.type === "required" && (
                                  <span className="errorMessage ">
                                    Select your{" "}
                                    {paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                      ? "currency"
                                      : paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? "token"
                                        : ""}
                                  </span>
                                )}
                              </div>
                            }
                            {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER && (
                              <>
                                <div className="col-md-6 mb-3">
                                  <div className="inputHolder inputHolderColumn m-0">
                                    <label className="label">Sending institution</label>
                                    <input
                                      maxLength={50}
                                      type="div"
                                      className="form-control bankTransferField"
                                      {...register("sendingInstruction", {
                                        required: true,
                                      })}
                                    />
                                  </div>
                                  {errors.sendingInstruction?.type === "required" && (
                                    <span className="errorMessage ">
                                      Enter your sending institution
                                    </span>
                                  )}
                                </div>

                                <div className="col-md-6 mb-3">
                                  <div className="inputHolder inputHolderColumn m-0">
                                    <label className="label">Account number</label>
                                    <input
                                      maxLength={50}
                                      type="div"
                                      className="form-control bankTransferField"
                                      {...register("number", validationRules)}
                                    />
                                  </div>

                                  {errors && errors.number && (
                                    <span className="errorMessage ">
                                      {errors?.number?.message}
                                    </span>
                                  )}
                                  {/* {errors.number?.type === "required" && (
                              <span className="errorMessage ">
                                Enter your account/token Number
                              </span>
                            )} */}
                                </div>

                                <div className="col-md-12 mb-3">
                                  <div className="inputHolder inputHolderColumn m-0">
                                    <label className="label">Account name</label>
                                    <input
                                      maxLength={40}
                                      type="div"
                                      className="form-control bankTransferField"
                                      {...register("nickName", {
                                        required: true,
                                      })}
                                    />
                                  </div>
                                  {errors.nickName?.type === "required" && (
                                    <span className="errorMessage ">
                                      Enter your account name
                                    </span>
                                  )}
                                </div>
                                <div className="col-md-6 mb-3">
                                  <div className="checkBoxSaveBank">
                                    <input
                                      type="checkbox"
                                      className="customCheckbox"
                                      checked={saveInfoWatch}
                                      onChange={handleToggle}
                                      id="saveInfoToggle"
                                    />
                                    <label htmlFor="saveInfoToggle" className="m-0" >
                                      Save bank info
                                    </label>
                                  </div>
                                </div>
                                <BankDetail toggleTransactionVisibility={toggleTransactionVisibility} isTransactionVisible={isTransactionVisible} bankTransferDetail={bankTransferDetail} />
                              </>
                            )}
                            {paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO && isTripleaUrl && <PayWithCryptoPopup url={isTripleaUrl} />}
                          </div>
                        </div>




                        <div style={{ marginTop: 12 }}>
                          <div>
                            <p className="header">
                              I will be sending the following{" "}
                              {paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                ? "estimated"
                                : ""}{" "}
                              amount
                            </p>
                          </div>

                          <div className="followingSection">
                            <div className="followingAmountAlign">
                              <div>
                                <p className="m-0 detailsAmountText">Price</p>
                              </div>
                              <div className="detailsAmountText detailsPriceText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                  stripePlans?.currency?.value
                                ) : (
                                  <Currency
                                    currency={stripePlans?.currency?.value || ""}
                                  />
                                )}{" "}
                                <CurrencyFormat
                                  currency={stripePlans?.currency?.value}
                                  value={parseFloat(cartAmount?.price)}
                                  decimal={2}
                                />
                                {isOverrideProduct && " x " + selectedQuantity?.value}
                              </div>
                            </div>

                            <div className="followingAmountAlign">
                              <div className="followingicon detailsAmountText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ||
                                  (paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO &&
                                    (parseInt(stripeType) ===
                                      SUBSCRIPTION_MODULE_TYPE.FUNDS ||
                                      parseInt(stripeType) ===
                                      SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL)) ||
                                  (stripePlans?.goldProductType?.value ===
                                    PRODUCT_GOLD_TYPE.KILOGRAM &&
                                    paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER)
                                  ? `Amount ${stripePlans?.goldProductType?.value ===
                                    PRODUCT_GOLD_TYPE.HEDGEKILOGRAM
                                    ? "to be hedged"
                                    : ""
                                  }`
                                  : "Sending amount"}
                                <div
                                  onClick={() =>
                                    handleClickInfo(
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                        ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                                        : paymentMethodSelection ===
                                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                          ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                                          : paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                            ? I_POP_OVER.STRIPE_AMOUNT
                                            : null
                                    )
                                  }
                                >
                                  <img src="assets/img/InfoIcon.png" className="infoIconImage" alt="info" />
                                </div>
                              </div>
                              <div className="detailsAmountText detailsPriceText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                  getValues("currency")?.value
                                ) : (
                                  <Currency
                                    currency={getValues("currency")?.value || ""}
                                  />
                                )}{" "}
                                <CurrencyFormat
                                  currency={getValues("currency")}
                                  value={
                                    getValues("baseAmountRate")
                                      ? parseFloat(getValues("baseAmountRate"))
                                      : "0"
                                  }
                                  decimal={
                                    paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                      ? 8
                                      : 2
                                  }
                                />
                              </div>
                            </div>

                            <div className="followingAmountAlign">
                              <div className="followingicon detailsAmountText">
                                {stripePlans?.goldProductType?.value ===
                                  PRODUCT_GOLD_TYPE.KILOGRAM &&
                                  paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                  ? "Storage fee"
                                  : `Transaction fee ${cartAmount?.charges}%`}
                                <div
                                  onClick={() =>
                                    handleClickInfo(
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER
                                        ? I_POP_OVER.BANK_TRANSFER_SENDING_AMOUNT
                                        : paymentMethodSelection ===
                                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                          ? I_POP_OVER.CRYPTO_TRANSFER_SENDING_AMOUNT
                                          : paymentMethodSelection ===
                                            SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD
                                            ? I_POP_OVER.STRIPE_TRANSACTION_FEES
                                            : null
                                    )
                                  }
                                >
                                  <img src="assets/img/InfoIcon.png" className="infoIconImage" alt="info" />
                                </div>
                              </div>
                              {paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ||
                                paymentMethodSelection ===
                                SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER ? (
                                paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ||
                                  (stripePlans?.goldProductType?.value ===
                                    PRODUCT_GOLD_TYPE.KILOGRAM &&
                                    paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.BANK_TRANSFER) ? (
                                  <div className="detailsAmountText detailsPriceText">
                                    {paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                      getValues("currency")?.value
                                    ) : (
                                      <Currency
                                        currency={getValues("currency")?.value || ""}
                                      />
                                    )}{" "}
                                    <CurrencyFormat
                                      currency={getValues("currency")}
                                      value={parseFloat(getValues("transactionFee"))}
                                      decimal={
                                        paymentMethodSelection ===
                                          SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                          ? 8
                                          : 2
                                      }
                                    />
                                  </div>
                                ) : (
                                  <div className="detailsAmountText">Included</div>
                                )
                              ) : (
                                <div className="detailsAmountText detailsPriceText">
                                  {paymentMethodSelection ===
                                    SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                    getValues("currency")?.value
                                  ) : (
                                    <Currency
                                      currency={getValues("currency")?.value || ""}
                                    />
                                  )}{" "}
                                  <CurrencyFormat
                                    currency={getValues("currency")}
                                    value={parseFloat(getValues("transactionFee"))}
                                    decimal={
                                      paymentMethodSelection ===
                                        SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                        ? 8
                                        : 2
                                    }
                                  />
                                </div>
                              )}
                            </div>
                            <hr
                              className="dootedHrLine"
                              style={{ marginBottom: "8px", marginTop: "0px" }}
                            />
                            <div className="followingAmountAlign">
                              <div>
                                <p className="m-0 detailsTotslAmountText">Total</p>
                              </div>
                              <div className="detailsTotslAmountText detailsPriceText">
                                {paymentMethodSelection ===
                                  SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? (
                                  getValues("currency")?.value
                                ) : (
                                  <Currency
                                    currency={getValues("currency")?.value || ""}
                                  />
                                )}{" "}
                                <CurrencyFormat
                                  currency={getValues("currency")}
                                  value={parseFloat(getValues("amount"))}
                                  decimal={
                                    paymentMethodSelection ===
                                      SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO
                                      ? 8
                                      : 2
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              {selectedStep === 4 && <PaymentStatus />}
              {selectedStep > 0 &&
                <>
                  {selectedStep !== 4 && !isTripleaUrl &&
                    <div className="container pb-5">
                      <div className="row">
                        <div className="col-4">
                          <div onClick={() => handleStep(1)} className="gobackButton">
                            <p className="m-0">Go back</p>
                          </div>
                        </div>
                        {(selectedStep === 2 && paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD && selectedCard) ?
                          <div className="col-8">
                            <button type="button" onClick={() => forwardPaymentPage(SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD)}
                              disabled={(selectedStep === 2 && !selectedCard) ? true : false}
                              className="gobackButton continueButton">

                              <p className="m-0">Continue</p>
                            </button>
                          </div>
                          : (selectedStep !== 2 &&
                            <div className="col-8">
                              <button type="button" onClick={() => {
                                if (selectedStep === 3) {
                                  handleSubmit(onSubmit(getValues()))
                                } else {
                                  if (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.PAIDUPCAPITAL || parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS) {
                                    if (!errors.baseAmountRate && getValues("baseAmountRate") >= 100) {
                                      dispatch(setPaymentSteps(2));
                                      dispatch(selectedCardFunc(null));
                                    }
                                  } else {
                                    dispatch(setPaymentSteps(2));
                                    dispatch(selectedCardFunc(null));
                                  }
                                }
                              }}
                                disabled={selectedStep === 3 && (amountWatch <= 0 || (parseInt(stripeType) === SUBSCRIPTION_MODULE_TYPE.FUNDS && cryptoAmountWatch < 100) || loader) ? true : false}
                                className="gobackButton continueButton">
                                {loader && (
                                  <i className="animateSpin fa-solid fa-circle-notch"></i>
                                )}
                                <p className="m-0">
                                  {selectedStep !== 3 ? "Continue" : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CARD ?
                                    <>
                                      Pay <Currency currency={getValues('currency')?.value || ''} />
                                      <CurrencyFormat
                                        currency={getValues('currency')}
                                        value={parseFloat(getValues('amount'))}
                                        decimal={paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? 8 : 2}
                                      />
                                    </>
                                    : paymentMethodSelection === SUPPORTED_PAYMENT_METHOD.PAY_WITH_CRYPTO ? "Pay now" : 'Complete'}</p>
                              </button>
                            </div>)
                        }
                      </div>
                    </div>
                  }
                  {selectedStep === 4 &&
                    <div className="container pb-5">
                      <div className="row">
                        <div className="col-md-12">
                          <div onClick={() => navigate(RoutesPaths.PAYMENT, {
                            state: { formData: 0, forceUpdate: true },
                          })} className="gobackButton continueButton">
                            <p className="m-0">View all transactions</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  }
                </>
              }
            </form>

          </div>
        </div >
      </div >

      <InfoModalStatic
        infoModalStaticShow={infoModalStaicShow}
        infoModalStaticClose={() => setInfoModalStaticShow(false)}
        infoModalStaicShowType={infoModalStaicShowType}
      />
    </>
  );
}
